var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticStyle: { height: "700px", width: "100%" } },
    [
      _c(
        "l-map",
        {
          ref: "myMap",
          attrs: {
            center: _vm.center,
            zoom: _vm.zoom,
            options: _vm.mapOptions,
          },
        },
        [
          _c("l-tile-layer", {
            attrs: { url: _vm.url, attribution: _vm.attribution },
          }),
          _vm._v(" "),
          _vm._l(_vm.locations, function (l, i) {
            return _c(
              "l-marker",
              {
                key: "lm" + i,
                ref: "markersRef",
                refInFor: true,
                attrs: { "lat-lng": { lat: l.lat, lng: l.lng } },
                on: {
                  click: function ($event) {
                    return _vm.$emit("item-selected", l)
                  },
                },
              },
              [
                _c("l-icon", {
                  attrs: {
                    "icon-url": _vm.iconUrl,
                    "icon-size": _vm.iconSize,
                    "icon-anchor": _vm.iconAnchor,
                  },
                }),
                _vm._v(" "),
                _c(
                  "l-popup",
                  {
                    attrs: { options: { permanent: true, interactive: true } },
                  },
                  [
                    _vm._v("\n      " + _vm._s(l.title) + " "),
                    l.title ? _c("br") : _vm._e(),
                    _vm._v(
                      " " +
                        _vm._s(l.address) +
                        ", " +
                        _vm._s(l.city) +
                        ", " +
                        _vm._s(l.state) +
                        " " +
                        _vm._s(l.zip) +
                        " \n    "
                    ),
                  ]
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }